import { ConfigProvider, Flex, Switch } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ComponentsDispatch, RootState } from '../../store';
import { setterCalendar } from '../../store/slices/calendarSlice';
import { ModeShowingTaskType } from '../../types';

const SwitchStatusTask = () => {
    const dispatch = useDispatch<ComponentsDispatch>();
    const modeShowingTask = useSelector<RootState, ModeShowingTaskType>((state) => state.calendar.modeShowingTask);

    const handleSwitch = (value: boolean) => {
        dispatch(setterCalendar({ modeShowingTask: value ? 'Outstanding' : 'Done' }));
    };

    return (
        <Flex>
            <ConfigProvider
                theme={{
                    components: {
                        Switch: {
                            // handleSize: 18,
                            // trackHeight: 22,
                            // trackMinWidth: 60,
                        },
                    },
                    token: {
                        colorTextQuaternary: '#4fbc31', //'#616161',
                    },
                }}
            >
                <Switch
                    checkedChildren={'Outstanding'}
                    unCheckedChildren={'Done'}
                    value={modeShowingTask === 'Outstanding'}
                    onChange={handleSwitch}
                />
            </ConfigProvider>
        </Flex>
    );
};

export default SwitchStatusTask;
